module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth) ? _c('div', [(!_vm.form_ErrorMessage) ? [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessageButton),
      expression: "localErrorMessageButton"
    }],
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessageClear)),
      expression: "localeFtc(localErrorMessageClear)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), _c('Table', {
    attrs: {
      "crud": "dns-records",
      "access": _vm.Access,
      "url-list": _vm.tableUrlList,
      "url-create": _vm.tableUrlCreate,
      "columns": _vm.tableColumns,
      "id-columns": "dns_id"
    },
    on: {
      "error": _vm.getError
    }
  })] : _c('errorAlert', {
    attrs: {
      "message": _vm.form_ErrorMessage
    }
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-636fa7be"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/crud/domainView.vue
// module id = 654
// module chunks = 0